import {useState} from "react";

let loader = {
    loading: 0
}

let callbacks = [];

export function startLoading() {
    loader.loading++;
    callbacks.forEach(callback => callback());
}

export function stopLoading() {
    loader.loading--;
    if (loader.loading < 0) loader.loading = 0;
    callbacks.forEach(callback => callback());
}


export function useLoader() {
    const [_loading, setLoading] = useState(loader.loading);

    callbacks.push(() => setLoading(loader.loading));

    return _loading;
}